import { makeAutoObservable } from "mobx";
import { startOfDay, endOfDay } from "date-fns";
import { getRequest } from "../lib/axios/ops-request";

export class DashboardStore {
    /**
     *  State
     */
    dashboard_data = null as any;
    loading = false as boolean;

    /**
     *  Constructor
     */
    constructor() {
        makeAutoObservable(this)
    }

    /**
     *  Request Method
     */
    async getDashboardReport(startDate?: Date, endDate?: Date) {
        this.loading = true;

        const now = new Date();
        const rangeStart = startDate ?? startOfDay(now);
        const rangeEnd = endDate ?? endOfDay(now);

        const response = await getRequest('/report/dashboard/package-summary', {
            start_date: rangeStart.toISOString(),
            end_date: rangeEnd.toISOString(),
        });

        if (response && typeof response === 'object') {
            this.dashboard_data = response;
        }

        this.loading = false;
    }
}

const dashboardStore = new DashboardStore();
export default dashboardStore;
